import { motion } from "framer-motion";

interface AnimatedButtonProps {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  children: React.ReactNode;
}

const AnimatedButton = ({ onClick, className, children,disabled }: AnimatedButtonProps) => {
  return (
    <motion.button
      className={className}
      onClick={onClick}
      disabled={disabled}
      whileHover={{ 
        // scale: 1.05,
        // transition: { duration: 0.2 }
        backgroundColor: "rgb(5 150 105)",
      }}
      viewport={{ once: false }}
      whileTap={{ scale: 0.95 }}
    >
      {children}
    </motion.button>
  );
};
18602660811
export default AnimatedButton; 